import React, { Component } from 'react';
import { Button, Breadcrumb, BreadcrumbItem, Col, Row, Modal, ModalBody, ModalHeader } from 'reactstrap';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import BootstrapTable from 'react-bootstrap-table-next';
import ProcessesDetail from '../../components/ProcessesDetail';
import { isFeatureEnabled } from '../../utils/Helpers';
import { DATAFLOWS_MS_PROCESSES } from '../../constants/processes';

class Processes extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      modalOpen: false,
    };
  }

  toggle() {
    this.setState({
      modalOpen: !this.state.modalOpen,
    });
  }
  render() {
    return (
      <div className='manage-users'>
        <Row className='subheader'>
          <Col className='col-8'>
            <h1>Processes</h1>
          </Col>
          <Col className='col-4'>
            <Breadcrumb>
              <BreadcrumbItem>
                <i className='icon ion-android-home'></i>
                <a href='#'>Home</a>
              </BreadcrumbItem>
              <BreadcrumbItem active>Processes</BreadcrumbItem>
            </Breadcrumb>
          </Col>
        </Row>
        <div className='page-cnt'>
          <Row>
            <BootstrapTable
              keyField={'processDefinitionId'}
              data={[
                {
                  processDefinitionId: 'cumulativeBillingProcess',
                  name: 'Start Billing Cycle',
                },
                {
                  processDefinitionId: 'changeOfTenancy',
                  name: 'Start Change Of Tenancy',
                },
                ...(isFeatureEnabled('isDataflowsMSIntegrationEnabled')
                  ? DATAFLOWS_MS_PROCESSES.map(({ processDefinitionId, name }) => ({ processDefinitionId, name }))
                  : []),
              ]}
              columns={[
                {
                  dataField: 'name',
                  text: 'Name',
                  sort: true,
                },
                {
                  formatter: (cell, row) => (
                    <span>
                      <Button
                        className={'icon ion-play'}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          this.setState({ modalOpen: true, processDefinitionId: row.processDefinitionId });
                        }}
                      ></Button>
                    </span>
                  ),
                },
              ]}
              rowEvents={{
                onMouseMove: (e, row, rowIndex) => {
                  e.target.move = true;
                },
                onMouseDown: (e, row, rowIndex) => {
                  e.target.move = false;
                },
              }}
            ></BootstrapTable>
          </Row>
        </div>
        <Modal isOpen={this.state.modalOpen} toggle={this.toggle} style={{ maxWidth: '90%' }}>
          <ModalHeader toggle={this.toggle}></ModalHeader>
          <ModalBody>
            <ProcessesDetail onClose={this.toggle} processDefinitionId={this.state.processDefinitionId} />
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default Processes;
